import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import { PrismAsyncLight as SyntaxHighlighter } from "react-syntax-highlighter";
import { coldarkDark as dark } from "react-syntax-highlighter/dist/cjs/styles/prism";
import remarkGfm from "remark-gfm";

const Previewer = ({ text, discussion = false }) => {
  return (
    <ReactMarkdown
      className={`p-2 text-xs prose max-h-64 max-w-full ${
        discussion ? "overflow-y-scroll min-h-[5rem]" : ""
      } overflow-x-hidden`}
      children={text}
      remarkPlugins={[remarkGfm]}
      components={{
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || "");
          return !inline && match ? (
            <SyntaxHighlighter
              children={String(children).replace(/\n$/, "")}
              style={dark}
              language={match[1]}
              PreTag="div"
              {...props}
            />
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          );
        },
      }}
    />
  );
};

export default Previewer;

Previewer.propTypes = {
  text: PropTypes.string.isRequired,
  discussion: PropTypes.bool,
};
